/* cc-crosssell.js – Cocochoco round 4 (2026-10-07): "Komplettera din behandling" tick-box add-ons.
   Loaded with defer only by snippets/cc-komplettera.liquid (product pages whose product has
   the metafield custom.komplettera). No prices are changed: every price shown comes from Shopify.
   - Ticked add-ons are added together with the main product in ONE /cart/add.js call when the customer
     uses the main buy button, the sticky bar (it clicks the main button) or the button in the block.
   - The cart drawer then opens with the new contents.
   - Add-ons already in the cart are hidden; Clarifying is hidden when a cart line includes it (the kit).
   - On failure a Swedish message is shown and nothing is half-added silently. */
(function () {
  'use strict';
  if (window.ccKompInit) return;
  window.ccKompInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ERR = 'Kunde inte lägga produkterna i varukorgen. Försök igen.';

  function kr(ore) {
    var n = ore / 100;
    var whole = Math.round(n) === n;
    try {
      return new Intl.NumberFormat('sv-SE', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(n) + ' kr';
    } catch (e) {
      return (whole ? String(n) : n.toFixed(2).replace('.', ',')) + ' kr';
    }
  }

  function blocks() { return Array.prototype.slice.call(document.querySelectorAll('[data-cc-komp]')); }

  function checkedItems(box) {
    return Array.prototype.slice.call(box.querySelectorAll('.cc-komp__item:not([hidden])')).filter(function (li) {
      var c = li.querySelector('.cc-komp__check');
      return c && c.checked;
    });
  }

  function itemVariant(li) {
    var sel = li.querySelector('.cc-komp__size');
    var c = li.querySelector('.cc-komp__check');
    if (sel) {
      var o = sel.options[sel.selectedIndex];
      return { id: parseInt(o.value, 10), price: parseInt(o.getAttribute('data-price'), 10) || 0 };
    }
    return { id: parseInt(c.value, 10), price: parseInt(c.getAttribute('data-price'), 10) || 0 };
  }

  /* 2026-10-10 round 2: a row can stand for several variants (the "Sulfatfritt Schampo + Balsam (set)" row):
     its checkbox carries data-ids="id1,id2" and data-price = the sum of the live prices. */
  function itemLines(li) {
    var c = li.querySelector('.cc-komp__check');
    var multi = c && c.getAttribute('data-ids');
    if (multi) {
      return {
        ids: multi.split(',').map(function (x) { return parseInt(x, 10); }).filter(function (x) { return x > 0; }),
        price: parseInt(c.getAttribute('data-price'), 10) || 0
      };
    }
    var v = itemVariant(li);
    return { ids: [v.id], price: v.price };
  }

  function mainForm(box) { return document.getElementById(box.getAttribute('data-form-id')); }

  function variantPrices(box) {
    var s = box.querySelector('[data-cc-komp-variants]');
    try { return JSON.parse(s.textContent); } catch (e) { return {}; }
  }

  function mainItem(box) {
    var form = mainForm(box);
    if (!form) return null;
    var fd = new FormData(form);
    var id = parseInt(fd.get('id'), 10);
    if (!id) return null;
    var item = { id: id, quantity: Math.max(1, parseInt(fd.get('quantity'), 10) || 1) };
    var props = {};
    fd.forEach(function (val, key) {
      var m = /^properties\[(.+)\]$/.exec(key);
      if (m && typeof val === 'string') props[m[1]] = val;
      if (key === 'selling_plan' && val) item.selling_plan = val;
    });
    if (Object.keys(props).length) item.properties = props;
    return item;
  }

  /* Button in the block: shown only when at least one add-on is ticked; the label carries the total
     (main product + ticked add-ons, plain addition of the shown prices). */
  function refreshButton(box) {
    var btn = box.querySelector('[data-cc-komp-add]');
    var label = box.querySelector('[data-cc-komp-label]');
    var picked = checkedItems(box);
    box.classList.toggle('cc-komp--picked', picked.length > 0);
    if (!btn) return;
    if (!picked.length) { btn.hidden = true; return; }
    var main = mainItem(box);
    var prices = variantPrices(box);
    var total = 0;
    var count = 1;
    if (main && prices[String(main.id)] != null) total += prices[String(main.id)] * main.quantity;
    picked.forEach(function (li) { var l = itemLines(li); total += l.price; count += l.ids.length; });
    label.textContent = 'Lägg till ' + count + ' produkter · ' + kr(total);
    btn.hidden = false;
  }

  function showError(box, form, detail) {
    var text = ERR + (detail && typeof detail === 'string' && detail.length < 140 ? ' (' + detail + ')' : '');
    var el = box.querySelector('.cc-komp__error');
    if (el) { el.textContent = text; el.hidden = false; }
    var pf = form && form.closest('product-form');
    var wrap = pf && pf.querySelector('.product-form__error-message-wrapper');
    var msg = wrap && wrap.querySelector('.product-form__error-message');
    if (wrap && msg) { msg.textContent = text; wrap.hidden = false; wrap.removeAttribute('hidden'); }
  }
  function clearError(box, form) {
    var el = box.querySelector('.cc-komp__error');
    if (el) { el.textContent = ''; el.hidden = true; }
    var pf = form && form.closest('product-form');
    var wrap = pf && pf.querySelector('.product-form__error-message-wrapper');
    if (wrap) wrap.hidden = true;
  }

  function setBusy(box, form, on) {
    var btns = [box.querySelector('[data-cc-komp-add]'), form && form.querySelector('[type=submit]')];
    btns.forEach(function (b) {
      if (!b) return;
      if (on) { b.setAttribute('aria-busy', 'true'); b.classList.add('loading'); b.setAttribute('aria-disabled', 'true'); }
      else { b.removeAttribute('aria-busy'); b.classList.remove('loading'); b.removeAttribute('aria-disabled'); }
      var sp = b.querySelector('.loading__spinner');
      if (sp) sp.classList.toggle('hidden', !on);
    });
  }

  function addAll(box) {
    var form = mainForm(box);
    var main = mainItem(box);
    if (!main) { showError(box, form); return; }
    var picked = checkedItems(box);
    /* Add-ons first, main product last: the cart lists the newest line first, so the main product
       ends up at the top of the drawer with its add-ons under it. */
    var items = [];
    picked.forEach(function (li) { itemLines(li).ids.forEach(function (id) { items.push({ id: id, quantity: 1 }); }); });
    items = items.reverse().concat([main]);
    var drawer = document.querySelector('cart-drawer');
    clearError(box, form);
    setBusy(box, form, true);
    var body = { items: items };
    if (drawer) {
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = window.location.pathname;
    }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.json().catch(function () { return { status: r.status || 500 }; }).then(function (state) {
          if (!r.ok && !state.status) state.status = r.status;
          return state;
        });
      })
      .then(function (state) {
        setBusy(box, form, false);
        if (state.status) { showError(box, form, state.description || state.message); return; }
        picked.forEach(function (li) { li.querySelector('.cc-komp__check').checked = false; });
        refreshButton(box);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cc-komplettera', productVariantId: main.id, cartData: state }); } catch (e) {}
        }
        if (drawer && typeof drawer.renderContents === 'function' && state.sections) {
          drawer.classList.contains('is-empty') && drawer.classList.remove('is-empty');
          drawer.renderContents(state);
        } else {
          window.location.href = root + 'cart';
          return;
        }
        syncWithCart();
      })
      .catch(function () { setBusy(box, form, false); showError(box, form); });
  }

  /* Hide add-ons that are already in the cart (and Clarifying when a cart line includes it). */
  function syncWithCart() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var ids = {};
        var clar = false;
        (cart.items || []).forEach(function (i) {
          ids[String(i.product_id)] = true;
          if (/Clarifying/i.test(i.variant_title || '')) clar = true;
        });
        blocks().forEach(function (box) {
          var visible = 0;
          box.querySelectorAll('.cc-komp__item').forEach(function (li) {
            var pids = (li.getAttribute('data-product-id') || '').split(',');
            var hide = pids.every(function (p) { return !!ids[p]; }) || (clar && li.getAttribute('data-clarifying') === '1');
            li.hidden = hide;
            if (hide) { var c = li.querySelector('.cc-komp__check'); if (c) c.checked = false; }
            else visible++;
          });
          box.hidden = visible === 0;
          refreshButton(box);
        });
      })
      .catch(function () {});
  }

  function init() {
    blocks().forEach(function (box) {
      var visible = box.querySelectorAll('.cc-komp__item:not([hidden])').length;
      box.hidden = visible === 0;
      refreshButton(box);
    });
  }

  document.addEventListener('change', function (e) {
    var box = e.target.closest && e.target.closest('[data-cc-komp]');
    if (box) {
      if (e.target.classList.contains('cc-komp__size')) {
        var c = e.target.closest('.cc-komp__item').querySelector('.cc-komp__check');
        if (c) c.checked = true;
      }
      refreshButton(box);
      return;
    }
    /* Quantity or variant change on the main product: update the total in the label. */
    if (e.target.closest && e.target.closest('product-info, .product__info-wrapper')) {
      setTimeout(function () { blocks().forEach(refreshButton); }, 400);
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cc-komp-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    addAll(btn.closest('[data-cc-komp]'));
  });

  /* Main buy button and sticky bar: when add-ons are ticked, add everything in one call instead of
     Dawn's single-product add. Capture phase, so this runs before Dawn's product-form handler. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    /* getAttribute: form.id would return the form's <input name="id"> (the variant id field). */
    var fid = form && form.getAttribute && form.getAttribute('id');
    if (!fid) return;
    var box = blocks().filter(function (b) { return b.getAttribute('data-form-id') === fid; })[0];
    if (!box || !checkedItems(box).length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var sub = form.querySelector('[type=submit]');
    if (sub && sub.getAttribute('aria-busy') === 'true') return;
    addAll(box);
  }, true);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    try {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (ev && ev.source === 'cc-komplettera') return;
        syncWithCart();
      });
      if (PUB_SUB_EVENTS.variantChange) subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(function () { blocks().forEach(refreshButton); }, 50); });
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
